import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Safely extract an error message string from an Axios error response.
 * Handles Pydantic 422 validation errors (array of {type, loc, msg}) and plain strings.
 */
export function getApiError(err, fallback = 'An error occurred') {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => d.msg || d.message || JSON.stringify(d)).join('; ') || fallback;
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail);
}

/**
 * iter426C (#9) — Display dates in DD/MM/YYYY everywhere a date is
 * SHOWN (not entered). Input pickers stay native. Accepts ISO string,
 * Date, or anything `new Date(...)` understands. Empty / invalid
 * input returns an em-dash so the UI never shows "Invalid Date".
 */
export function formatDDMMYYYY(value) {
  if (value == null || value === '') return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

/**
 * This/Last/Next month shortcuts for Sales Invoicing date-range filters.
 * offsetMonths: 0 = current month, -1 = last month, 1 = next month.
 * Returns {from, to} as 'YYYY-MM-DD' strings (inclusive calendar month).
 */
export function getMonthRangeISO(offsetMonths = 0) {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() + offsetMonths, 1);
  const last = new Date(now.getFullYear(), now.getMonth() + offsetMonths + 1, 0);
  const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { from: toISO(first), to: toISO(last) };
}

